import { Lens, Fold, Getter } from "@discovery/prelude/lib/control/lens";
import * as Res from "@discovery/sonic-api-ng/lib/japi/response";
import { _Response2ResponseData } from "./common";
/**
 * Getters
 */
export const _PageGetter = Getter.of();
export const _PageResponseGetter = Getter.of();
export const _PageItemGetter = Getter.of();
/**
 * Lenses
 */
export const _PageResponse2Page = _Response2ResponseData();
export const _Page2Data = Fold.compose(_PageGetter, Res._Response());
export const _PageItem2Data = Fold.compose(_PageItemGetter, Res._Response());
export const _Page2Attributes = Fold.compose(_Page2Data, Lens.prop("attributes"));
export const _PageItem2Attributes = Fold.compose(_PageItem2Data, Lens.prop("attributes"));
export const _PageAttributes2Alias = Fold.compose(_Page2Attributes, Lens.prop("alias"));
export const _PageAttributes2Component = Fold.compose(_Page2Attributes, Lens.prop("component"));
export const _PageAttributes2Description = Fold.compose(_Page2Attributes, Lens.prop("description"));
export const _PageAttributes2Hints = Fold.compose(_Page2Attributes, Lens.prop("hints"));
export const _PageAttributes2Name = Fold.compose(_Page2Attributes, Lens.prop("name"));
export const _PageAttributes2PageMetadataAuthor = Fold.compose(_Page2Attributes, Lens.prop("pageMetadataAuthor"));
export const _PageAttributes2PageMetadataDescription = Fold.compose(_Page2Attributes, Lens.prop("pageMetadataDescription"));
export const _PageAttributes2PageMetadataKeywords = Fold.compose(_Page2Attributes, Lens.prop("pageMetadataKeywords"));
export const _PageAttributes2PageMetadataTitle = Fold.compose(_Page2Attributes, Lens.prop("pageMetadataTitle"));
export const _PageAttributes2Title = Fold.compose(_Page2Attributes, Lens.prop("title"));
export const _Page2Images = Fold.compose(_PageGetter, Res._Rel("images"), Res._ForEach());
export const _Page2Items = Fold.compose(_PageGetter, Res._Rel("items"), Res._ForEach());
export const _Page2Routes = Fold.compose(_PageGetter, Res._Rel("routes"), Res._ForEach());
export const _Page2PrimaryContentTaxonomyNode = Fold.compose(_PageGetter, Res._RelAssoc("primaryContent", "taxonomyNode"));
export const _Page2PrimaryContentImage = Fold.compose(_PageGetter, Res._RelAssoc("primaryContent", "image"));
export const _Page2PrimaryContentShow = Fold.compose(_PageGetter, Res._RelAssoc("primaryContent", "show"));
export const _Page2PrimaryContentChannel = Fold.compose(_PageGetter, Res._RelAssoc("primaryContent", "channel"));
export const _Page2PrimaryContentVideo = Fold.compose(_PageGetter, Res._RelAssoc("primaryContent", "video"));
export const _Page2PrimaryContentArticle = Fold.compose(_PageGetter, Res._RelAssoc("primaryContent", "article"));
export const _PageItemAttributes2CallToAction = Fold.compose(_PageItem2Attributes, Lens.prop("callToAction"));
export const _PageItemAttributes2Description = Fold.compose(_PageItem2Attributes, Lens.prop("description"));
export const _PageItemAttributes2Hints = Fold.compose(_PageItem2Attributes, Lens.prop("hints"));
export const _PageItemAttributes2Title = Fold.compose(_PageItem2Attributes, Lens.prop("title"));
export const _PageItem2Collection = Fold.compose(_PageItemGetter, Res._Rel("collection"));
export const _PageItem2Images = Fold.compose(_PageItemGetter, Res._Rel("images"));
export const _PageItem2Link = Fold.compose(_PageItemGetter, Res._Rel("link"));
export const _PageItem2Show = Fold.compose(_PageItemGetter, Res._Rel("show"));
export const _PageItem2Channel = Fold.compose(_PageItemGetter, Res._Rel("channel"));
export const _PageItem2TaxonomyNode = Fold.compose(_PageItemGetter, Res._Rel("taxonomyNode"));
export const _PageItem2Video = Fold.compose(_PageItemGetter, Res._Rel("video"));
export const _PageItem2Article = Fold.compose(_PageItemGetter, Res._Rel("article"));

